;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export const USER_RESTRICTION_TYPES = {
  NOT_RESTRICTED: 'not_restricted',
  WATCHLIST: 'watchlist',
  AML: 'aml',
  BLOCK: 'block',
  FINAL: 'final',
  FIRST_REJECTION: 'first_rejection',
} as const;

export type UserRestrictionType =
  (typeof USER_RESTRICTION_TYPES)[keyof typeof USER_RESTRICTION_TYPES];

export interface UserRestriction {
  type: UserRestrictionType;
}

export const RESTRICTION_MODAL_VARIANTS = {
  NONE: 'none',
  SUSPENSION: 'suspension',
  FINAL_REJECTION: 'finalRejection',
  FIRST_REJECTION: 'firstRejection',
} as const;

export type RestrictionModalVariant =
  (typeof RESTRICTION_MODAL_VARIANTS)[keyof typeof RESTRICTION_MODAL_VARIANTS];
